import { RichTextWUT } from '@wix/form-fields/viewer-wut';

export default RichTextWUT;
